import { float, Fn, max, vec3 } from "three/tsl"

export const blendBrightenFloat = Fn(([base, blend]: [any, any]) => {
  return max(blend, base)
})

export const blendBrighten = Fn(([base, blend]: [any, any]) => {
  return vec3(
    blendBrightenFloat(base.r, blend.r),
    blendBrightenFloat(base.g, blend.g),
    blendBrightenFloat(base.b, blend.b),
  )
})

export const blendBrightenAlpha = Fn(
  ([base, blend, alpha]: [any, any, any]) => {
    return blendBrighten(base, blend)
      .mul(alpha)
      .add(base.mul(float(alpha).oneMinus()))
  },
)
